import { DataService } from "../../services/data.service";
import { BusinesLogicService } from "../../services/business-logic.service";
import { DatePipe } from "@angular/common";
import { UtilsService } from "../../services/utils.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
var DeskQueueComponent = (function () {
    function DeskQueueComponent(_data, _blogic, datePipe, _utils) {
        this._data = _data;
        this._blogic = _blogic;
        this.datePipe = datePipe;
        this._utils = _utils;
        this.search = '';
        this.orderType = null;
        this.orderReverse = false;
        this.turns = [];
        this.interval = null;
        this.destroy$ = new Subject();
    }
    DeskQueueComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getTurns();
        if (this.interval == null) {
            this.interval = setInterval(function (e) {
                _this.getTurns();
            }, 15000);
        }
    };
    DeskQueueComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.interval);
        this.destroy$.next();
        this.destroy$.complete();
    };
    DeskQueueComponent.prototype.openModal = function () {
        $("#deskQueueModal").modal('show');
    };
    DeskQueueComponent.prototype.orderBy = function (type, onlyRefresh) {
        if (onlyRefresh === void 0) { onlyRefresh = false; }
        this.orderType = type;
        if (!onlyRefresh) {
            this.orderReverse = !this.orderReverse;
        }
    };
    DeskQueueComponent.prototype.getTurns = function () {
        var _this = this;
        var params = {
            queue_id: this._data.session["qdesk_id"],
            session_id: this._data.session["session"]
        };
        if (this._blogic.turnInProgress && this._blogic.lastQueueData) {
            this.filter(this._blogic.lastQueueData);
            return;
        }
        this.getTurnsSub = this._blogic.getTurnList(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._blogic.lastQueueData = response;
            _this._blogic.turnInProgress = false;
            var actualDate = _this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss').toString();
            for (var e = 0; e < response.length; e++) {
                if (response[e]['lastredirect'] != null && !(typeof response[e]['lastredirect'] == 'number')) {
                    response[e]['lastredirect'] = _this._utils.getWaitTime(response[e]['lastredirect'], actualDate, false, false);
                }
                else {
                    response[e]['lastredirect'] = _this._utils.getWaitTime(response[e]['initdatetime'], actualDate, false, false);
                }
                _this.filter(response);
                _this.orderBy(_this.orderType, true);
            }
        });
    };
    DeskQueueComponent.prototype.filter = function (list) {
        var _this = this;
        var onlyActiveTurns = [];
        list.forEach(function (e) {
            if (e.enddatetime == null && e.printed == true && e.paused == null && parseInt(e.queue_id) == parseInt(_this._data.session["qdesk_id"])) {
                onlyActiveTurns.push(e);
            }
        });
        this.turns = onlyActiveTurns;
    };
    DeskQueueComponent.prototype.call = function (id) {
        var _this = this;
        if (id === void 0) { id = null; }
        var params = {
            desk_id: this._data.session["desk"],
            queue_id: this._data.session["qdesk_id"],
            turn_id: id,
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"]
        };
        this._blogic.setTurn(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            if (response != null) {
                if (response["turn_id"] == "-1") {
                    _this._data.closeTurn();
                }
                else {
                    _this._data.turn = response;
                }
                $("#deskQueueModal").modal('hide');
            }
        });
    };
    return DeskQueueComponent;
}());
export { DeskQueueComponent };
